import React from "react";
import bck from "../../images/pnf.jpg";
import "./PageNotFound.scss";
const PageNotFound = () => {
  return (
    <div className="no-page">
      <img src={bck} alt="" />
    </div>
  );
};

export default PageNotFound;
